import { useState, useMemo } from "react";
import { Container, Row } from "reactstrap";

import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";
import Loader from "../../Components/Common/Loader";
import {
  useDeleteRecruitment,
  useRecruitments,
} from "../../hooks/useRecruitments";
import { getStoredAuthUser } from "../../utils/backendApi";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import defaultIllustration from "../../assets/images/lcbtp.png";

const RecruitmentsPage = (props) => {
  const { data: recrutements, isLoading, isError, error } = useRecruitments();

  const deleteMutation = useDeleteRecruitment();

  const recrutementsList = Array.isArray(recrutements)
    ? recrutements
    : recrutements?.results || [];

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [selectedRecruitment, setSelectedRecruitment] = useState(null);

  const onClickDelete = (recruitment) => {
    setSelectedRecruitment(recruitment);
    setDeleteModal(true);
  };

  const handleDeleteRecruitment = () => {
    if (selectedRecruitment && selectedRecruitment.id) {
      deleteMutation.mutate(selectedRecruitment.id, {
        onSettled: () => setDeleteModal(false),
      });
    }
  };

  const role = Boolean(
    (getStoredAuthUser()?.role ?? []).some((role) => role === "assistant")
  );

  const [dele, setDele] = useState(0);

  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      // dispatch(deleteProducts(element.value));
      del.style.display = "none";
    });
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("REF"),
        accessor: "reference",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 italic">
                  <Link className="text-dark">
                    {" "}
                    {recruitments.row.original.reference}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("ILLUSTRATION"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <img
                  src={recruitments.row.original.offer_pic || defaultIllustration}
                  alt={props.t("Illustration")}
                  className="avatar-sm rounded"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultIllustration;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TITRE"),
        accessor: "title",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center ">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 uppercase"
                  style={{ textTransform: "uppercase", fontWeight: "bold" }}
                >
                  {recruitments.row.original.title}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("DESCRIPTIF"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5
                  className="fs-14 mb-1 "
                  style={{
                    width: 200,
                    height: 50,
                    overflow: "clip",
                    verticalAlign: "middle",
                  }}
                >
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-dark"
                  ></Link>
                  {recruitments.row.original.description}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("PUBLIE"),
        accessor: "publication_date",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="">
                <h5
                  className=" mb-1 badge badge-soft-primary"
                  style={{ textAlign: "center" }}
                >
                  <Link
                    to={`/#/${recruitments.row.original.id}/`}
                    className="text-dark "
                  ></Link>
                  {recruitments.row.original.publication_date}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("CLOTURE"),
        accessor: "closure_date",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {new Date() >
                new Date(recruitments.row.original.closure_date) ? (
                  <h5
                    className="mb-1 badge badge-soft-danger "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${recruitments.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {recruitments.row.original.closure_date}
                  </h5>
                ) : (
                  <h5
                    className="mb-1 badge badge-soft-warning "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${recruitments.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {recruitments.row.original.closure_date}
                  </h5>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("STATUT"),
        accessor: "closed",
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {new Date() >
                new Date(recruitments.row.original.closure_date) ? (
                  <h5
                    className=" mb-1 badge badge-soft-danger "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${recruitments.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {"Cloturé"}
                  </h5>
                ) : (
                  <h5
                    className="mb-1 badge badge-soft-success me-1 "
                    style={{ textAlign: "center" }}
                  >
                    <Link
                      to={`/#/${recruitments.row.original.id}/`}
                      className="text-dark "
                    ></Link>
                    {"En cours"}
                  </h5>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("FICHIER"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {recruitments.row.original.offer_file ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      className="text-xs rounded"
                      href={recruitments.row.original.offer_file}
                      target="_blank"
                      title="Télécharger"
                    >
                      <i
                        style={{
                          fontSize: "30px",
                          width: "50%",
                          height: "50%",
                          color: "red",
                        }}
                        className="ri-file-download-fill align-bottom"
                      ></i>
                    </a>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      style={{ fontSize: "30px", width: "50%", height: "50%" }}
                      className="ri-link align-bottom"
                    ></i>
                  </div>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("STATUT"),
        Cell: (recruitments) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14  p-2">
                  <span className="mt-4">
                    {recruitments.row.original.published === false && !role ? (
                      <div>
                        <div className="btn btn-soft-success">
                          <Link
                            to={`/recruitments-details/${recruitments.row.original.id}/`}
                          >
                            Publier
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <h5
                        className="mb-1 badge badge-soft-success "
                        style={{ fontSize: "10px" }}
                      >
                        Publiée
                      </h5>
                    )}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const recruitmentsData = cellProps.row.original;
          return (
            <div className="d-flex gap-2">
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/recruitments-update/${recruitmentsData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/recruitments-details/${recruitmentsData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-eye-fill"></i>
                </Link>
              </li>

              <li className="list-inline-item" title={props.t("Supprimer")}>
                <Link
                  to="#"
                  className="text-danger d-inline-block"
                  onClick={() => onClickDelete(recruitmentsData)}
                >
                  <i className="ri-delete-bin-5-line align-middle"></i>
                </Link>
              </li>
            </div>
          );
        },
      },
    ],
    [props]
  );

  document.title = props.t("Liste des offres d'emplois");

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return (
      <Loader error={error?.message || props.t("Erreur lors du chargement")} />
    );
  }

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteRecruitment}
        onCloseClick={() => setDeleteModal(false)}
        isPending={deleteMutation.isPending}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des offres d'emploi")}
          pageTitle={props.t("Listes des offres d'emploi")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {recrutementsList.length ? (
                    <TableContainer
                      columns={columns}
                      data={recrutementsList || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle table-borderless"
                      theadClass="table-light text-muted"
                      isRecrutementsFilter={true}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                      <div className="mt-4">
                        <Link to="/recruitments-add" className="btn btn-warning">
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          {props.t("Ajouter une offre d'emploi")}
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
RecruitmentsPage.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(RecruitmentsPage));
